module.exports = __webpack_public_path__ + "img/hc_sub.fa2429a0.jpg";